<!-- Wizard page title

Props:

* {String} title (required) - Title text

-->
<template>
  <b-row>
    <b-col>
      <h2 class="mt-2 mb-2">
        {{ title }}
      </h2>
    </b-col>
  </b-row>
</template>

<style lang="scss" scoped>
h2 {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>

<script>
export default {
  name: 'WizardPageTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
